"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = exports.Footer = exports.Header = exports.MessageList = exports.ResponsiveContainer = exports.getIcon = exports.Icon = exports.UnreadIndicator = exports.TimeAgo = exports.ActionElement = exports.TextElement = exports.Title = exports.PositionRelative = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CourierSvg = function CourierSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#9121C2",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.838 10.662a.306.306 0 0 0 .074-.294C23.882 4.515 18.779.058 12.618.058 5.69.059.088 5.692.148 12.619.19 19.338 5.867 24.985 12.587 25c5.706.015 10.53-3.809 12.03-9.03.058-.176-.044-.367-.22-.44l-.516-.192c-2-.706-4.22-.456-6 .706-.808.53-1.411.97-1.411.97a6.284 6.284 0 0 1-3.56 1.089c-3.514 0-5.985-2.868-6.367-6.368l-.28-1.911a1.666 1.666 0 0 0-1.029-1.295l-.72-.279a.193.193 0 0 1-.089-.309c3.015-4.03 6.692-3.147 6.692-3.147a3.501 3.501 0 0 1 1.647.603c.661.456 1.161 1.103 1.485 1.838A7.34 7.34 0 0 0 21 11.647c.015 0 2.882.118 3.838-.985z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.809 7.647a.72.72 0 1 0 0-1.441.72.72 0 0 0 0 1.441zM7.97 11.456c.177 1.132 1.074 4.72 5.06 5.382.058.015.088-.073.029-.103-.927-.426-3.338-1.823-5-5.323-.015-.03-.103-.015-.088.044z"
  })));
};

CourierSvg.defaultProps = {
  className: "icon",
  width: "25",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg"
};

var CourierBigSvg = function CourierBigSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#9121C2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.64 15.304c.106-.106.148-.276.106-.424C34.26 6.432 26.894 0 18 0 8.003 0-.084 8.13 0 18.127.064 27.827 8.258 35.98 17.958 36c8.236.021 15.198-5.498 17.363-13.033.085-.255-.063-.53-.318-.637l-.743-.276a9.847 9.847 0 0 0-8.66 1.02c-1.168.763-2.038 1.4-2.038 1.4a9.07 9.07 0 0 1-5.137 1.57c-5.073 0-8.639-4.138-9.19-9.19l-.404-2.76a2.405 2.405 0 0 0-1.486-1.868l-1.04-.403a.28.28 0 0 1-.127-.446c4.35-5.816 9.657-4.542 9.657-4.542.956.085 1.741.446 2.378.87.955.658 1.677 1.592 2.144 2.653a10.595 10.595 0 0 0 9.743 6.368c.02 0 4.16.17 5.54-1.422z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.06 10.953a1.04 1.04 0 1 0 0-2.08 1.04 1.04 0 0 0 0 2.08zM11.293 16.45c.255 1.635 1.55 6.814 7.302 7.77.085.02.127-.107.042-.15-1.337-.615-4.818-2.631-7.216-7.683-.022-.043-.15-.021-.128.063z"
  })));
};

CourierBigSvg.defaultProps = {
  className: "icon",
  width: "36",
  height: "36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var PositionRelative = _styledComponents["default"].div.withConfig({
  displayName: "styled__PositionRelative",
  componentId: "sc-1ene6tj-0"
})(["position:relative;"]);

exports.PositionRelative = PositionRelative;

var Title = _styledComponents["default"].div.withConfig({
  displayName: "styled__Title",
  componentId: "sc-1ene6tj-1"
})(function (_ref) {
  var _theme$message;

  var theme = _ref.theme,
      read = _ref.read;
  return (0, _deepExtend["default"])({
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "16px",
    textAlign: "left",
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: read ? "var(--ci-text-color)" : "var(--ci-title-color)"
  }, (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : _theme$message.title);
});

exports.Title = Title;

var TextElement = _styledComponents["default"].div.withConfig({
  displayName: "styled__TextElement",
  componentId: "sc-1ene6tj-2"
})(function (_ref2) {
  var _theme$message2;

  var theme = _ref2.theme;
  return (0, _deepExtend["default"])({
    color: "var(--ci-text-color)",
    marginTop: "1px",
    wordBreak: "break-word",
    fontSize: "12px",
    fontStyle: "normal",
    maxWidth: 250,
    fontWeight: "400",
    lineHeight: "16px",
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-line",
    p: {
      margin: 0
    }
  }, (_theme$message2 = theme.message) === null || _theme$message2 === void 0 ? void 0 : _theme$message2.textElement);
});

exports.TextElement = TextElement;

var ActionElement = _styledComponents["default"].button.withConfig({
  displayName: "styled__ActionElement",
  componentId: "sc-1ene6tj-3"
})(function (_ref3) {
  var _ref4, _theme$brand, _theme$brand$colors, _theme$message3;

  var theme = _ref3.theme,
      primary = _ref3.primary,
      backgroundColor = _ref3.backgroundColor;
  var primaryColor = (_ref4 = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme === null || theme === void 0 ? void 0 : (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary) !== null && _ref4 !== void 0 ? _ref4 : "#9121c2";
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  return (0, _deepExtend["default"])({
    borderRadius: 6,
    color: primary ? "white" : "rgba(28, 39, 58, 1)",
    background: primary ? primaryColor : "white",
    wordBreak: "break-word",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "16px",
    height: "24px",
    padding: "0 16px",
    cursor: "pointer",
    border: "1px solid ".concat(primary ? "transparent" : "rgba(28, 39, 58, 1)"),
    marginRight: "12px",
    marginTop: "6px",
    transition: "all 100ms ease-in",
    "&:hover": {
      color: "white",
      background: primary ? tcPrimaryColor.lighten(10) : "rgba(28, 39, 58, 1)"
    }
  }, (_theme$message3 = theme.message) === null || _theme$message3 === void 0 ? void 0 : _theme$message3.actionElement);
});

exports.ActionElement = ActionElement;

var TimeAgo = _styledComponents["default"].div.withConfig({
  displayName: "styled__TimeAgo",
  componentId: "sc-1ene6tj-4"
})(function (_ref5) {
  var _theme$message4;

  var theme = _ref5.theme;
  return (0, _deepExtend["default"])({
    color: "var(--ci-text-color)",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "14px",
    whiteSpace: "nowrap",
    maxWidth: "90px",
    textOverflow: "ellipsis",
    overflow: "hidden"
  }, (_theme$message4 = theme.message) === null || _theme$message4 === void 0 ? void 0 : _theme$message4.timeAgo);
});

exports.TimeAgo = TimeAgo;

var iconStyles = function iconStyles(_ref6) {
  var _theme$brand$colors$p, _theme$brand2, _theme$brand2$colors, _theme$message5;

  var theme = _ref6.theme;
  return (0, _deepExtend["default"])({
    height: 25,
    width: 25,
    flexShrink: "0",
    path: {
      fill: (_theme$brand$colors$p = theme === null || theme === void 0 ? void 0 : (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.primary) !== null && _theme$brand$colors$p !== void 0 ? _theme$brand$colors$p : "#9121c2"
    }
  }, (_theme$message5 = theme.message) === null || _theme$message5 === void 0 ? void 0 : _theme$message5.icon);
};

var bigIconStyles = function bigIconStyles(_ref7) {
  var _theme$brand$colors$p2, _theme$brand3, _theme$brand3$colors, _theme$message6;

  var theme = _ref7.theme;
  return (0, _deepExtend["default"])({
    height: 36,
    width: 36,
    flexShrink: "0",
    path: {
      fill: (_theme$brand$colors$p2 = theme === null || theme === void 0 ? void 0 : (_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$colors = _theme$brand3.colors) === null || _theme$brand3$colors === void 0 ? void 0 : _theme$brand3$colors.primary) !== null && _theme$brand$colors$p2 !== void 0 ? _theme$brand$colors$p2 : "#9121c2"
    }
  }, (_theme$message6 = theme.message) === null || _theme$message6 === void 0 ? void 0 : _theme$message6.icon);
};

var UnreadIndicator = _styledComponents["default"].div.withConfig({
  displayName: "styled__UnreadIndicator",
  componentId: "sc-1ene6tj-5"
})(function (_ref8) {
  var _theme$brand$colors$p3, _theme$brand4, _theme$brand4$colors, _theme$message7;

  var theme = _ref8.theme;
  return (0, _deepExtend["default"])({
    height: 8,
    width: 8,
    backgroundColor: (_theme$brand$colors$p3 = theme === null || theme === void 0 ? void 0 : (_theme$brand4 = theme.brand) === null || _theme$brand4 === void 0 ? void 0 : (_theme$brand4$colors = _theme$brand4.colors) === null || _theme$brand4$colors === void 0 ? void 0 : _theme$brand4$colors.primary) !== null && _theme$brand$colors$p3 !== void 0 ? _theme$brand$colors$p3 : "#9121c2",
    borderRadius: "50%",
    position: "absolute",
    left: "13px"
  }, theme === null || theme === void 0 ? void 0 : (_theme$message7 = theme.message) === null || _theme$message7 === void 0 ? void 0 : _theme$message7.unreadIndicator);
});

exports.UnreadIndicator = UnreadIndicator;

var Icon = _styledComponents["default"].img.withConfig({
  displayName: "styled__Icon",
  componentId: "sc-1ene6tj-6"
})(iconStyles);

exports.Icon = Icon;
var CourierIcon = (0, _styledComponents["default"])(CourierSvg).withConfig({
  displayName: "styled__CourierIcon",
  componentId: "sc-1ene6tj-7"
})(iconStyles);
var CourierBigIcon = (0, _styledComponents["default"])(CourierBigSvg).attrs({
  className: "icon"
}).withConfig({
  displayName: "styled__CourierBigIcon",
  componentId: "sc-1ene6tj-8"
})(bigIconStyles);

var getIcon = function getIcon(icon, big) {
  return (0, _react.useMemo)(function () {
    if (icon === false) {
      return;
    }

    if (icon && typeof icon === "string") {
      return /*#__PURE__*/_react["default"].createElement(Icon, {
        className: "icon",
        src: icon
      });
    }

    if (big) {
      return /*#__PURE__*/_react["default"].createElement(CourierBigIcon, null);
    }

    return /*#__PURE__*/_react["default"].createElement(CourierIcon, null);
  }, [icon]);
};

exports.getIcon = getIcon;

var ResponsiveContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__ResponsiveContainer",
  componentId: "sc-1ene6tj-9"
})(function (_ref9) {
  var theme = _ref9.theme,
      isMobile = _ref9.isMobile;
  return (0, _deepExtend["default"])(_objectSpread({}, isMobile ? {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh"
  } : {}), theme === null || theme === void 0 ? void 0 : theme.container);
});

exports.ResponsiveContainer = ResponsiveContainer;

var MessageList = _styledComponents["default"].div.withConfig({
  displayName: "styled__MessageList",
  componentId: "sc-1ene6tj-10"
})(function (_ref10) {
  var _theme$messageList;

  var isMobile = _ref10.isMobile,
      theme = _ref10.theme;
  var defaultHeight = 392;

  var height = function () {
    if (!isMobile) {
      return defaultHeight;
    }

    return "Calc(100vh - 205px)";
  }();

  return (0, _deepExtend["default"])({
    background: "rgba(255, 255, 255, 0.2)",
    overflow: "auto",
    display: "flex",
    height: height,
    maxHeight: height,
    flexDirection: "column",
    borderTop: "1px solid rgba(203,213,224,.5)"
  }, theme === null || theme === void 0 ? void 0 : (_theme$messageList = theme.messageList) === null || _theme$messageList === void 0 ? void 0 : _theme$messageList.container);
});

exports.MessageList = MessageList;

var Header = _styledComponents["default"].div.withConfig({
  displayName: "styled__Header",
  componentId: "sc-1ene6tj-11"
})(function (_ref11) {
  var theme = _ref11.theme;
  return (0, _deepExtend["default"])({
    padding: "18px 20px 12px 20px",
    userSelect: "none",
    display: "flex",
    color: "#24324b",
    justifyContent: "space-between",
    fontSize: "18px",
    fontWeight: "700",
    lineHeight: "25px"
  }, theme === null || theme === void 0 ? void 0 : theme.header);
});

exports.Header = Header;

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "styled__Footer",
  componentId: "sc-1ene6tj-12"
})(function (_ref12) {
  var theme = _ref12.theme;
  return (0, _deepExtend["default"])({
    alignItems: "center",
    background: "white",
    display: "flex",
    fontSize: "10px",
    fontStyle: "normal",
    letterSpacing: ".1rem",
    position: "relative",
    zIndex: 1,
    boxShadow: "0 14px 11px 18px #3445632e",
    fontWeight: "700",
    height: 45,
    justifyContent: "center",
    paddingRight: 18,
    svg: {
      marginTop: 2,
      marginLeft: -1
    },
    a: {
      display: "inherit",
      color: "#B9C0CD"
    }
  }, theme === null || theme === void 0 ? void 0 : theme.footer);
});

exports.Footer = Footer;

var Line = _styledComponents["default"].div.withConfig({
  displayName: "styled__Line",
  componentId: "sc-1ene6tj-13"
})(function (_ref13) {
  var _theme$brand$colors$p4, _theme$brand5, _theme$brand5$colors;

  var theme = _ref13.theme;
  return {
    backgroundColor: (_theme$brand$colors$p4 = theme === null || theme === void 0 ? void 0 : (_theme$brand5 = theme.brand) === null || _theme$brand5 === void 0 ? void 0 : (_theme$brand5$colors = _theme$brand5.colors) === null || _theme$brand5$colors === void 0 ? void 0 : _theme$brand5$colors.primary) !== null && _theme$brand$colors$p4 !== void 0 ? _theme$brand$colors$p4 : "#9121c2",
    height: "4px",
    flex: 1,
    opacity: "0.18",
    ":first-child": {
      marginRight: "15px"
    },
    ":last-child": {
      marginLeft: "15px"
    }
  };
});

exports.Line = Line;